import { Inject, Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/observable/throw'
// import 'rxjs/add/operator/catch';

import { managerInfoModel } from 'src/app/models/managerInfoModel';
import { userModel } from 'src/app/models/userModel';
import { IGetMemberInfoResponseModel } from './models/customerService/M01002';
import { Base64 } from 'js-base64';

@Injectable()
export class httpInterceptor implements HttpInterceptor {
    constructor(@Inject('BASE_URL') private baseUrl: string) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if(req.url.indexOf('/api') == 1 || req.url.indexOf('/api') == 0)
        {
            // Clone the request to add the new header.
            let authReq: HttpRequest<any> = req.clone();

            if(!req.headers.has("filename"))
            {
              authReq = authReq.clone(
                {
                    headers: authReq.headers
                        .append("Content-Type", "application/json")
                }
              );
            }

            if (sessionStorage.length > 0 && sessionStorage.getItem("jwtToken") != null) {
              const jwtToken = sessionStorage.getItem("jwtToken");

              authReq = authReq.clone(
                    {
                        headers: authReq.headers
                            .append("Authorization", `Bearer ${jwtToken}`)
                    }
                );
            }

            if(sessionStorage.getItem("manager") != null)
            {
                var managerInfo = new managerInfoModel().transTo(JSON.parse(Base64.decode(sessionStorage.getItem("manager"))));

                authReq = authReq.clone(
                    {
                        headers: authReq.headers
                            .append("managerid", managerInfo.id)
                            .append("accesstoken", managerInfo.accessToken)
                    }
                );
            }

            if(sessionStorage.getItem("user") != null)
            {
                var user = new userModel().transTo(JSON.parse(sessionStorage.getItem("user")));
                authReq = authReq.clone(
                    {
                        headers: authReq.headers
                            .append("userid", user.id)
                            .append("companyid", user.companyid)
                            .append("logintoken", user.app_token)
                    }
                );
            }

            if (sessionStorage.getItem("csuser") != null) {
              var csuser = <IGetMemberInfoResponseModel>(JSON.parse(sessionStorage.getItem("csuser")));
              authReq = authReq.clone(
                  {
                      headers: authReq.headers
                          .append("loginToken", csuser.loginToken)
                  }
              );
            }

            authReq = authReq.clone({url : `${this.baseUrl}${req.url.substring(1)}`});  //this.baseUrl + req.url.substring(1)

            //send the newly created request
            return next.handle(authReq) as any;
        }
      //   else if (req.url.indexOf('/api') > -1) {
      //     // H03000 影片上傳 的 Content-Type 必須是 "multipart/form-data"
      //     let authReq: HttpRequest<any> = req.headers.get('authorization').endsWith("4600CC62-8AE3-4413-8617-4E6807C517E8") ?
      //         req.clone(
      //             {
      //                 headers: req.headers
      //                     .append("Content-Type", "multipart/form-data")
      //             }
      //         )
      //         : req.clone(
      //             {
      //                 headers: req.headers
      //                     .append("Content-Type", "application/json")
      //             }
      //         );

      //     if (sessionStorage.getItem("csuser") != null) {
      //         var csuser = <IGetMemberInfoResponseModel>(JSON.parse(sessionStorage.getItem("csuser")));
      //         authReq = authReq.clone(
      //             {
      //                 headers: authReq.headers
      //                     .append("loginToken", csuser.loginToken)
      //             }
      //         );
      //     }

      //     return next.handle(authReq) as any;
      // }
      else
      {
        if(!req.url.toLowerCase().startsWith("http"))
          req = req.clone({url : `${this.baseUrl}${req.url.substring(1)}`})   // this.baseUrl + req.url.substring(1)
        return next.handle(req) as any;
      }
    }
}
